// extracted by mini-css-extract-plugin
module.exports = {"root":"_3lLp6","metricName":"_86C9Y","value":"BBtdH","current":"_1x002","delta":"_2l6_o","multipleRuns":"_1V9gx","unchanged":"_3JaAZ"};